<template>
  <div class="social-links">
    <a class="item" @click.prevent="openwindow(`http://www.facebook.com/sharer.php?u=${origin}${path}`)" :href="`http://www.facebook.com/sharer.php?u=${origin}${path}`"><img class="icon" src="../assets/facebook.svg" alt=""/></a>
    <a class="item" @click.prevent="openwindow(`https://twitter.com/share?url=${origin}${path}&text=Geh%20aus%2C%20mein%20Herz%20-%20Evangelischer%20Liederschatz%20-%2022%2B2%20Lieder&lang=&quot;de&quot;`);" :href="`https://twitter.com/share?url=${origin}${path}&text=Geh%20aus%2C%20mein%20Herz%20-%20Evangelischer%20Liederschatz%20-%2022%2B2%20Lieder&lang=&quot;de&quot;`"><img class="icon" src="../assets/twitter.svg" alt=""/></a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      origin: encodeURIComponent(window.location.origin)
    }
  },
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    openwindow(url) {
      const fenster = window.open(url, "socialwindow", "width=600,height=600,status=yes,scrollbars=yes,resizable=yes");
      fenster.focus();
    },
    pathString() {
      if (this.path) {
        this.path = encodeURIComponent(this.path);
      }
    }
  }
}
</script>